"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyItem = void 0;
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const common_1 = require("../../../common");
const account_1 = require("../../base/account");
const ui_1 = require("../ui");
const types_1 = require("./types");
const DropDownInput_1 = require("../ui/DropDownInput");
const moment_1 = __importDefault(require("moment"));
exports.CompanyItem = react_1.default.memo(({ id, isModify }) => {
    const user = (0, react_redux_1.useSelector)((state) => (0, account_1.getUserInfo)(state));
    const passwordRef = react_1.default.useRef(null);
    const rePasswordRef = react_1.default.useRef(null);
    // 회사명 중복 체크 여부
    const [isNameCheck, setIsNameCheck] = react_1.default.useState(false);
    // 회사 ID 중복 체크 여부
    const [isIdCheck, setIsIdCheck] = react_1.default.useState(false);
    // 접속 URL 중복 체크 여부
    const [isUrlCheck, setIsUrlCheck] = react_1.default.useState(false);
    const [item, setItem] = react_1.default.useState(types_1.DEFAULT_COMPANY_ITEM);
    const [password, setPassword] = react_1.default.useState('');
    const [rePassword, setRePassword] = react_1.default.useState('');
    const [companyName, setCompanyName] = react_1.default.useState('');
    const [companyId, setCompanyId] = react_1.default.useState('');
    const [url, setUrl] = react_1.default.useState('');
    const [serviceSetting, setServiceSetting] = react_1.default.useState('');
    const [serviceStart, setServiceStart] = react_1.default.useState('');
    const [serviceEnd, setServiceEnd] = react_1.default.useState('');
    // (onClick) 취소 버튼 클릭 시 이전 페이지로 이동
    const cancelMenu = () => {
        APP.eventManager.publish('PREVIOUS_MENU');
    };
    // (onClick) 비밀번호 초기화 버튼 클릭 시 비밀번호 초기화
    const handlerResetPassword = () => {
        if (passwordRef.current)
            passwordRef.current.setValue('');
        if (rePasswordRef.current)
            rePasswordRef.current.setValue('');
        setPassword('');
        setRePassword('');
    };
    // (onClick) 버튼 클릭 시 회사 정보 삭제
    const handlerDelete = () => {
        if (!id)
            return;
        console.log('삭제');
    };
    // (onClick) 버튼 클릭 시 회사 정보 등록 및 수정
    const handlerSubmit = () => {
        if (id) {
            if (isModify) {
                // 수정 패이지
                console.log('수정');
                console.log({
                    companyName,
                    companyId,
                    url,
                    serviceSetting,
                    serviceStart,
                    serviceEnd,
                    password,
                    rePassword,
                });
            }
            else {
                // 상세 페이지 - 수정 페이지로 이동
                APP.eventManager.publish('CHANGE_MENU', {
                    showDepth: 'modify',
                    props: { id },
                });
            }
        }
        else {
            // 등록 페이지
            console.log({
                companyName,
                companyId,
                url,
                serviceSetting,
                serviceStart,
                serviceEnd,
                password,
                rePassword,
            });
        }
    };
    react_1.default.useEffect(() => {
        if (!!id) {
            const data = {
                name: 'name' + id,
                id: 'id' + id,
                url: 'url' + id,
                userId: 'userId',
                serviceSetting: 'serviceSetting',
                serviceStart: (0, moment_1.default)().format('YYYY-MM-DD'),
                serviceEnd: (0, moment_1.default)().format('YYYY-MM-DD'),
            };
            // 상세 페이지
            setItem(data);
            setCompanyName(data.name);
            setCompanyId(data.id);
            setUrl(data.url);
            setServiceSetting(data.serviceSetting);
            setServiceStart(data.serviceStart);
            setServiceEnd(data.serviceEnd);
        }
        else {
            setItem(types_1.DEFAULT_COMPANY_ITEM);
        }
    }, [id]);
    return (react_1.default.createElement("div", { className: "regist_container" },
        react_1.default.createElement("form", { onSubmit: e => e.preventDefault() },
            react_1.default.createElement("div", { className: "regist_box_wrapper" },
                react_1.default.createElement("div", { className: "regist_box" },
                    react_1.default.createElement(ui_1.TextInput, { title: "\uD68C\uC0AC\uBA85", handlerUpdate: setCompanyName, defaultValue: item.name, disabled: !isModify, noShowButtonArea: !isModify, buttonOption: isModify && {
                            title: '중복 체크',
                            className: 'btn-semi-round btn-blue btn-xmd',
                            handlerClick: () => {
                                console.log('중복 체크');
                            },
                        } }),
                    react_1.default.createElement(ui_1.TextInput, { title: "\uD68C\uC0AC ID", handlerUpdate: setCompanyId, defaultValue: item.id, disabled: !isModify, noShowButtonArea: !isModify, buttonOption: isModify && {
                            title: '중복 체크',
                            className: 'btn-semi-round btn-blue btn-xmd',
                            handlerClick: () => {
                                console.log('중복 체크');
                            },
                        } }),
                    react_1.default.createElement(ui_1.TextInput, { title: "\uC544\uC774\uB514", noShowButtonArea: !isModify, disabled: true, defaultValue: user?.id, autoComplete: "username" }),
                    isModify && (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(ui_1.TextInput, { ref: passwordRef, type: "password", title: "\uBE44\uBC00\uBC88\uD638", disabled: !isModify, noShowButtonArea: !isModify, handlerUpdate: setPassword, buttonOption: {
                                title: '초기화',
                                className: 'btn-semi-round btn-peach btn-xmd',
                                handlerClick: handlerResetPassword,
                            }, autoComplete: "new-password" }),
                        react_1.default.createElement(ui_1.TextInput, { ref: rePasswordRef, type: "password", title: "\uBE44\uBC00\uBC88\uD638 \uD655\uC778", handlerUpdate: setRePassword, autoComplete: "new-password" })))),
                react_1.default.createElement("div", { className: "regist_box" },
                    react_1.default.createElement(ui_1.TextInput, { title: "\uC811\uC18D URL", defaultValue: item.url, disabled: !isModify, noShowButtonArea: !isModify, handlerUpdate: setUrl, buttonOption: isModify && {
                            title: '중복 체크',
                            className: 'btn-semi-round btn-blue btn-xmd',
                            handlerClick: () => {
                                console.log('중복 체크');
                            },
                        } }),
                    react_1.default.createElement(ui_1.TextInput, { type: "date", title: "\uC11C\uBE44\uC2A4 \uC2DC\uC791\uC77C", defaultValue: item.serviceStart, disabled: !isModify, noShowButtonArea: !isModify, handlerUpdate: setServiceStart }),
                    react_1.default.createElement(ui_1.TextInput, { type: "date", title: "\uC11C\uBE44\uC2A4 \uC885\uB8CC\uC77C", defaultValue: item.serviceEnd, disabled: !isModify, noShowButtonArea: !isModify, handlerUpdate: setServiceEnd }),
                    react_1.default.createElement(DropDownInput_1.DropDownInput, { title: "\uC11C\uBE44\uC2A4 \uC124\uC815", disabled: !isModify, noShowButtonArea: !isModify, noSelectOption: {
                            show: true,
                            id: null,
                            title: '선택 안함',
                        }, defaultValue: '1', dropdownList: [
                            {
                                id: '1',
                                value: '서비스 설정 1',
                            },
                        ], handlerUpdate: setServiceSetting })))),
        react_1.default.createElement("div", { className: "btn-container" },
            !!id && !isModify && (react_1.default.createElement(common_1.Button, { text: "\uC0AD\uC81C", className: "btn-default-round btn-peach btn-xmd", onClick: handlerDelete })),
            react_1.default.createElement(common_1.Button, { text: !id ? '등록' : '수정', className: "btn-default-round btn-blue btn-xmd", onClick: handlerSubmit }),
            react_1.default.createElement(common_1.Button, { text: "\uCDE8\uC18C", className: "btn-default-round btn-grey btn-xmd", onClick: cancelMenu }))));
});
